import { stringify } from 'qs';

const toQueryString = (params) =>
  stringify(params, {
    arrayFormat: 'repeat',
    filter: (prefix, value) => {
      if (value === null) return undefined;
      return value;
    },
  });

export const getQueryUrl = ({ path = window.location.pathname, params }) => {
  const queryString = toQueryString(params);
  return queryString.length ? `${path}?${queryString}` : path;
};

export const replaceUrl = ({ path, params, hash = window.location.hash }) => {
  const url = `${getQueryUrl({ path, params })}${hash}`;
  window.history.replaceState(null, '', url);
};

export const pushUrl = ({ path, params, hash = window.location.hash }) => {
  const url = `${getQueryUrl({ path, params })}${hash}`;
  window.history.pushState(null, '', url);
};
